export function getDnevnaEvidencija(dnevnaEvidencija) {
    return { type: 'GET_DNEVNA_EVIDENCIJA', dnevnaEvidencija };
}
